export default __webpack_public_path__ + "static/O0242-cb88b9f8263fde83f0bc8aa1e1c99754.png";